import {
	BigNum,
	QUOTE_PRECISION_EXP,
	SpotMarketConfig,
} from '@velocity-exchange/sdk';
import { BaseAssetDisplaySymbol } from '@velocity-exchange/common';
import useAccountTargetSpotBalance from 'src/hooks/useAccountTargetSpotBalance';
import { AccountData } from 'src/stores/useVelocityAccountsStore';
import { formatText, PRESETS } from '@velocity-exchange/common/format';

export const BalanceChanges = ({
	selectedCollatBank,
	targetAccountKey,
	selectedTargetAccount,
	collatTransferAmountBigNum,
	assetCurrentPrice,
	baseAssetDisplaySymbol,
}: {
	selectedCollatBank: SpotMarketConfig;
	targetAccountKey: string;
	selectedTargetAccount: AccountData;
	collatTransferAmountBigNum: BigNum;
	assetCurrentPrice: BigNum;
	baseAssetDisplaySymbol: BaseAssetDisplaySymbol;
}) => {
	const targetAccountBankBalance = useAccountTargetSpotBalance(
		selectedCollatBank,
		targetAccountKey
	);

	const targetAccountCurrentNetBaseBalance =
		targetAccountBankBalance.netBaseBalance;

	const targetAccountTotalNetQuoteValue = BigNum.from(
		selectedTargetAccount?.client?.getNetSpotMarketValue() ?? 0,
		QUOTE_PRECISION_EXP
	);

	const quoteAmountToAdd =
		selectedCollatBank?.symbol == 'USDT'
			? collatTransferAmountBigNum.shiftTo(QUOTE_PRECISION_EXP)
			: collatTransferAmountBigNum
					.shiftTo(QUOTE_PRECISION_EXP)
					.mul(assetCurrentPrice)
					.shiftTo(QUOTE_PRECISION_EXP);

	return (
		<div className="flex flex-col gap-sm">
			<div className="flex items-center justify-between gap-xs">
				<span className="typo-body-xs text-text-secondary">
					New Asset Balance
				</span>
				<span className="typo-body-xs text-text-default">
					{`${targetAccountCurrentNetBaseBalance
						.add(collatTransferAmountBigNum)
						.prettyPrint()} ${baseAssetDisplaySymbol}`}
				</span>
			</div>
			<div className="flex items-center justify-between gap-xs">
				<span className="typo-body-xs text-text-secondary">
					New Net Account Balance (USD)
				</span>
				<span className="typo-body-xs text-text-default">
					{formatText(
						targetAccountTotalNetQuoteValue.add(quoteAmountToAdd).toNum(),
						PRESETS.balance
					)}
				</span>
			</div>
		</div>
	);
};
